import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
}) => {
  const sizeMap: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
    small: 'h-5 w-5 border-2',
    medium: 'h-10 w-10 border-4',
    large: 'h-16 w-16 border-4',
  };

  return (
    <div className="flex flex-col items-center justify-center p-5">
      <div
        className={`animate-spin rounded-full border-slate-200 border-t-enpal-downriver ${sizeMap[size]}`}
      />
      {message && (
        <p className="mt-4 text-center text-sm text-enpal-stone-grey">{message}</p>
      )}
    </div>
  );
};

